import { PaintStyle, FontSizeCalculator } from "../../drawing";
import { AbstractTextItem } from "./AbstractTextItem";
import { IFreeInputable } from "./IFreeInputable";
import { IPaintable } from "./IPaintable";
import { SeparatorKinds } from "../SeparatorKinds";
import { ITextLengthValidatable } from "./ITextLengthValidatable";

export abstract class AbstractPlainTextItem extends AbstractTextItem implements IFreeInputable, IPaintable, ITextLengthValidatable {
  constructor(typeKey: string, value: any) {
    super(typeKey, value);
  }

  public paintStyle: PaintStyle = new PaintStyle();
  public isFreeInputable: boolean = false;
  public shouldInputFree: boolean = false;

  /** 文字の長さチェック */
  public enableLengthCheck: boolean;
  public lengthChecklength: number;

  protected applyMembers(clone: AbstractPlainTextItem): void {
    super.applyMembers(clone);
    clone.paintStyle = this.cloneValue(this.paintStyle);
    clone.isFreeInputable = this.cloneValue(this.isFreeInputable);
    clone.shouldInputFree = this.cloneValue(this.shouldInputFree);
    clone.enableLengthCheck = this.cloneValue(this.enableLengthCheck);
    clone.lengthChecklength = this.cloneValue(this.lengthChecklength);
  }

  public getTextLength(): number {
    const text = this.text();
    return !!text ? text.length : 0;
  }

  // value(string/number)をそのまま検証対象とする場合はこのままでOK
  // value以外の値やvalueをstring/number以外として扱う場合は、派生クラスでオーバーライドする事
  protected valueToText(value: any): string {
    switch (typeof value) {
      case "string":
        return value;
      case "number":
        return value + "";
      default:
        return "";
    }
  }

  protected getDelimitor(kind: SeparatorKinds): string {
    switch (kind) {
    case SeparatorKinds.MiddlePoint:
      return "・";
    case SeparatorKinds.NewLine:
      return "\n";
    case SeparatorKinds.Comma:
      return "、";
    case SeparatorKinds.WideComma:
      return "，";
    case SeparatorKinds.WideSpace:
      return "　";
    case SeparatorKinds.None:
    default:
      return "";
    }
  }

  protected getAdjustedFontSize(isMultiLine: boolean): number {
    return this.getAdjustedTextFontSize(this.text(), isMultiLine);
  }

  protected getAdjustedTextFontSize(text: string, isMultiLine: boolean): number {
    return FontSizeCalculator.calculate(
      isMultiLine,
      this.geometry.rectangle.size,
      this.textStyle.baseFontSize,
      this.textStyle.lineHeight,
      text);
  }

  abstract getDisplayName(): string;
}
